<template>
  <div class="sever">
    <div class="content_banner">
      <img src="../../assets/img/banner/banner_server.jpg" alt="">
    </div>

    <div class="container_wrap">
      <el-row :gutter="30">
        <el-col :span="5">
          <div class="side_hd">
            <h2>管理团队</h2>
            <p>MANAGEMENT TEAM</p>
          </div>
          <div class="side_wrap">
            <ul>
              <li v-for="(item,index) in sideNav" :class="{'active' : cur == item.id}" :key="index" @click="sideNavActice(item,index)">
                <a href="javascript:;">{{item.name}}</a>
              </li>
            </ul>
          </div>
        </el-col>
        <el-col :span="19">
          <div class="contTit">
            <h2>管理团队</h2>
            <p><router-link to="/">首页</router-link> · <a href="/team">管理团队</a> · <span>{{titleRight}}</span></p>
          </div>
          <div class="contRWrap">
            <ul class="cont_list team_list">
              <li v-for="(item,index) in list" :key="index">
                <el-row :gutter="20">
                  <el-col :span="24">
                    <div class="team_title">{{item.name}}</div>
                    <div class="team_inner">{{item.info}}</div>
                  </el-col>
                </el-row>
              </li>
            </ul>

            <team-leader ref="teamLeader" v-if="type == 1" :groupId="cur"></team-leader>
            <team-department ref="teamDepartment" v-if="type == 2" :groupId="cur"></team-department>

          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import teamLeader from '../../components/teamLeader.vue'
import teamDepartment from '../../components/teamDepartment.vue'
export default {
  name: 'news',
  components: {
    teamLeader,
    teamDepartment
  },
  data(){
    return{
      groupId: null,
      type: null, // 1:领导班子；2:部门；
      cur: 0,
      sideNav: [
      ],
      titleRight: '',
      list: [],
      total: 10,
      currentPage: 1,
      id: ''
    }
  },
  mounted: function(){
    var _this = this

    _this.getSeverNav()

    // var urlId = _this.$router.history.current.query.id

    // setTimeout(() => {
    //   if(urlId){
    //     _this.cur = urlId
    //     _this.id = urlId
    //     _this.sideNav.forEach(line =>{
    //       if(line.id == urlId){
    //         _this.titleRight =  line.name
    //       }
    //     })
    //   }else{
    //     _this.cur = _this.sideNav[0].id
    //     _this.id = _this.sideNav[0].id
    //     _this.titleRight = _this.sideNav[0].name
    //   }

    //   if (_this.cur && _this.cur == 6) {
    //     _this.type = 1
    //   } else {
    //     _this.type = 2
    //   }
    //   // _this.getDetail(_this.id)
    // }, 500)
  },
  created: function(){
    
  },
  watch: {
    '$route': function () {
      var _this = this
      if(_this.$route.meta){
        _this.cur = _this.$route.meta.sub ? _this.$route.meta.sub : 0
      }

      var urlId = _this.$router.history.current.query.id
      if(urlId){
        _this.cur = urlId
        _this.id = urlId
        _this.sideNav.forEach(line =>{
          if(line.id == urlId){
            _this.titleRight =  line.name
          }
        })
      }else{
        _this.cur = _this.sideNav[0].id
        _this.id = _this.sideNav[0].id
        _this.titleRight = _this.sideNav[0].name
      }
      // _this.getDetail(_this.id)
    }
  },
  methods: {
    // 侧导航
    sideNavActice(item){
      // console.log('index :>> ', index);
      var _this = this

      _this.cur = item.id
      _this.titleRight = item.name
      _this.type = null
      setTimeout(() => {
        if (_this.cur && _this.cur == 6) {
          _this.type = 1
        } else {
          _this.type = 2
        }
        // _this.getDetail(item.id)
      }, 500)
    },
    async getSeverNav(){
      var _this = this
      var { data } = await _this.$http.post(_this.apiUrl + '/managementTeam/getManagementTeamTypeList');
      if(data.code == 200){
        _this.sideNav = data.data
        if (data.data.length) {
          _this.cur = _this.sideNav[0].id
          _this.id = _this.sideNav[0].id
          _this.titleRight = _this.sideNav[0].name
          if (_this.cur && _this.cur == 6) {
            _this.type = 1
          } else {
            _this.type = 2
          }
        }
      }
    },
    async getDetail(id){
      var _this = this
      var { data } = await _this.$http.post(_this.apiUrl + '/managementTeam/getManagementTeamInfoList',{classification: id});
      if(data.code == 200){
        _this.list = data.data.list
        _this.total = data.data.total
      }
    }
  }
}
</script>
